import React from "react";

const OurRegistrationDetails = () => {
  const registrationData = [
    { category: "Registered Name", details: "RUPESH RAJ PROPRIETOR OF NEXTERA RESEARCH" },
    { category: "Registration Number", details: "INH000020280 " },
    { category: "Type of Registration", details: "Individual" },
    { category: "Validity", details: "Apr 17, 2025-Apr 16, 2030" },
    { category: "Contact Person", details: "Rupesh Raj " },
    { category: "Contact Email", details: "customer@nexteraresearch.in" },
    { category: "Contact Phone", details: "+91 9891904233" },
    {
      category: "Compliance Email",
      details: "compliance@nexteraresearch.in",
    },
    {/*
      category: "Office Address",
      details:
        "MZ 01 B Zone Business Spaces, Nipaniya Square Indore 452010",
    */},
    {
      category: "SEBI regional/local office address",
      details:
        "1st Floor, Satguru Parinay, 104-105, AB Rd, Opposite C-21 Mall, Scheme No 54, Indore, Madhya Pradesh 452010 ",
    },
  ];

  return (
    <div className="w-full max-w-5xl mx-auto py-16 sm:py-20 px-4 md:px-6 lg:px-8">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] text-center">
        Our Registration Details
      </h1>

      <div className="overflow-x-auto mt-12">
        <table className="w-full border-collapse rounded-lg shadow-lg overflow-hidden">
          <thead className="text-white bg-[#1E3A8A]">
            <tr>
              <th className="p-4 text-left uppercase tracking-wider">
                Category
              </th>
              <th className="p-4 text-left uppercase tracking-wider">
                Details
              </th>
            </tr>
          </thead>
          <tbody>
            {registrationData.map((item, index) => (
              <tr
                key={index}
                className="odd:bg-gray-100 even:bg-white border-b transition duration-300 ease-in-out hover:bg-[#E0F2FE] hover:scale-[1.01] cursor-pointer"
              >
                <td className="p-4 font-medium text-[#0F172A]">
                  {item.category}
                </td>
                <td className="p-4 text-[#1F2937] break-words">
                  {item.details}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OurRegistrationDetails;
